import {Tr} from "@/i18n/i18n";
import {VerticalStandardPanel} from "@/scenes.ui/vertical-standard-panel";
import Scene = Phaser.Scene;
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import {SquareButton} from "@/scenes.ui/square-button";
import CreaturePanel from "@/scenes.ui/creature-panel";
import {ShopCreature} from "@/store/shop/types";
import SoundUtils from "@/utils/sound-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import GameObject = Phaser.GameObjects.GameObject;

export class BuyCreatureConfirmationPanel extends VerticalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, depth: number, creature: ShopCreature, onAcceptCallback: () => unknown, isSquadFull: boolean,
                maxCreatures: number) {
        super(scene, canvas, creature.creatures.length > 1? Tr('priobretenie.sputnikov') : Tr('priobretenie.sputnika'));

        this.setDepth(depth);

        let clickSound = SoundUtils.addSound(this.scene!, Keys.SOUND_BUTTON_CLICK);

        let gameObjects:GameObject[] = [];
        let step = 110;
        let dx = 0 - (creature.creatures.length - 1) / 2 * step;
        creature.creatures.forEach(c => {
            let creatureName = TextUtils.addTextByFamily(scene, c.name.toUpperCase(), dx, -25,
                '#716F6A', 14, 'bold', 450, Fonts.MYRIADPRO_BOLD);

            let creaturePanel: CreaturePanel = new CreaturePanel(scene, dx, -130, c, () => undefined, true);
            gameObjects.push(creatureName, creaturePanel);
            dx += step;
        });

        let acceptButton = new SquareButton(scene, 0, 135, 0, Keys.UI_ART_GREEN_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('da'), false, 80, 80);

        acceptButton.setCallback(() => {
            SoundUtils.play(clickSound);
            if (this.isOnTop()) {
                if (onAcceptCallback != null) { onAcceptCallback(); }
                this.close();
            }
        });

        this.add([...gameObjects, acceptButton]);

        if (isSquadFull) {

            let title = TextUtils.addTextByFamily(scene, Tr('v.boju.mogut.uchastvovat.lish') + maxCreatures + ' ' + Tr('heroes') + '!', 0, 20,
                '#ffd465', 14, 'bold', 450, Fonts.MYRIADPRO_BOLD);

            let willBeExcluded = creature.creatures.length > 1? Tr('4ast.budet.iskl' ) : Tr('odin.iz.starih.geroev.budet.iskljuchen.iz.otrjada');
            let title2 = TextUtils.addTextByFamily(scene, willBeExcluded, 0, title.getBottomCenter().y! / CU.S + 30,
                '#716F6A', 12, 'bold', 400, Fonts.MYRIADPRO_BOLD);

            let title3 = TextUtils.addTextByFamily(scene, Tr('vi.smozhete.v.ljuboy.moment.izmenit.sostav.geroev'), 0, title2.getBottomCenter().y! / CU.S + 20,
                '#716F6A', 12, 'bold', 400, Fonts.MYRIADPRO_BOLD);

            acceptButton.setText(Tr('kupit'));
            acceptButton.setY(title3.getBottomCenter().y! + 85 * CU.S);
            acceptButton.setTextY(45 * CU.S);

            this.add([title, title2, title3]);

        } else {

            let title = TextUtils.addTextByFamily(scene, Tr('gotovi.priobresti.sputnika'), 0, 30,
                '#ffd465', 16, 'bold', 450, Fonts.MYRIADPRO_BOLD);

            this.add([title]);

        }

        SpriteUtils.scale(this, 0.9 / CU.S);
    }
}
